import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "device-registration"

  connect() {
    super.connect()

    this.send("connect", {}, (message) => {
      if (message.data?.token) {
        this.#registerDevice(message.data.token)
      }
    })
  }

  async #registerDevice(token) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    try {
      await fetch("/auth/devices", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
        },
        body: JSON.stringify({ token, platform: "apple" }),
      })
    } catch (error) {
      console.error("Failed to register device:", error)
    }
  }
}
